import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "utils";

export const residentOnboard = createAsyncThunk('residentOnboard', async ({ values }) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'onboarding_premise_user',
            data: {
                'premise_id': values?.premise_id,
                'users': values?.users,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") },

        })
        return res
    } catch (error) {
        return error.response
    }
})